<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box" v-if="ay_std_div_list != null">
      <v-toolbar class="toolbar no-display" flat dense>
        <v-toolbar-title>
          <strong> Exam Customize Report </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center" dense class="no-display">
        <v-col cols="12" sm="2" md="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="sel_ay_data"
            return-object
            :items="ay_std_div_list"
            item-text="ay"
            label="Select Academic Year"
            outlined
            @change="getStd()"
            persistent-hint
            hint="Please select academic year"
          />
        </v-col>
        <v-col cols="12" sm="2" md="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            dense
            required
            outlined
            rounded
            color="#0F2027"
            v-model="sem"
            :items="semester_list"
            item-text="display_name"
            item-value="id"
            label="Semester"
            persistent-hint
            hint="Please select semester"
          />
        </v-col>
        <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="sel_std_data"
            return-object
            :items="std_div_list"
            item-text="std"
            label="Standard"
            outlined
            @change="
              getDiv();
              getStandardCourse();
            "
            persistent-hint
            hint="Please select standard"
            @click="putnull"
          />
        </v-col>
        <v-col cols="12" sm="2" md="2" v-if="div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="div"
            item-value="div_off_id"
            :items="div_list"
            item-text="div_name"
            label="Division"
            outlined
            persistent-hint
            hint="Please select division"
          />
        </v-col>
        <v-col cols="12" sm="2" md="2" v-if="quota_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="quota"
            item-value="id"
            :items="quota_list"
            item-text="name"
            label="Quota"
            outlined
            persistent-hint
            hint="Please select quota"
          />
        </v-col>
        <!-- <v-col cols="12" sm="2" md="2" v-if="default_value != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="value" item-value="id" :items="default_value" item-text="value" label="Percentage" outlined persistent-hint hint="Please select Percentage" />
                </v-col> -->
        <v-col cols="12" sm="2" md="2" v-if="default_value != null">
          <v-icon color="error">*</v-icon>
          <v-text-field
            v-model="default_value.min"
            type="number"
            label="From Percentage"
            dense
            outlined
            rounded
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="2" md="2" v-if="default_value != null">
          <v-icon color="error">*</v-icon>
          <v-text-field
            v-model="default_value.max"
            type="number"
            label="To Percentage"
            dense
            outlined
            rounded
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="4" v-if="crs_list != ''">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            @change="
              assessment_detail_list = '';
              assessment_detail = null;
            "
            color="#0F2027"
            dense
            rounded
            required
            v-model="crs_id"
            item-value="c_id"
            :items="crs_list"
            item-text="course"
            label="Course"
            multiple
            outlined
            persistent-hint
            hint="Please select course"
          />
        </v-col>
        <v-col v-if="crs_id != ''" cols="12" sm="2" md="2">
          <v-btn class="mt-6 button" @click="getassessmentschemedetails()"
            >Get Assessment Type</v-btn
          >
        </v-col>
        <v-col cols="12" sm="4" md="4" v-if="assessment_detail_list != ''">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="assessment_detail"
            item-value="assessmenttype"
            :items="assessment_detail_list"
            item-text="assessmenttype"
            label="Assessment Scheme Details"
            outlined
            persistent-hint
            hint="Please select assessment scheme details"
          />
        </v-col>
        <v-col
          cols="12"
          sm="2"
          md="2"
          v-if="
            sel_ay_data && sel_std_data && div && crs_id && assessment_detail
          "
        >
          <v-btn
            class="mt-6 button"
            @click="getreport()"
            :loading="fetch_loader"
            >Get Report</v-btn
          >
        </v-col>
      </v-row>
    </v-card>
    <v-card class="box" v-if="learner_course_list != ''">
      <!-- excel btn code -->
      <v-row dense>
        <v-col cols="12" sm="6" md="6">
          <v-btn
            rounded
            color="success"
            outlined
            @click="fnExcelReport('my-table-id', 'ExamCustReport')"
            :loading="loader"
            ><v-icon color="success">mdi-export</v-icon>Export</v-btn
          >
        </v-col>
      </v-row>
      <v-col cols="12" sm="12" md="12" v-if="learner_course_list != ''">
        <div id="my-table-id">
          <v-simple-table fixed-header dense class="elevation-1">
            <thead>
              <tr>
                <th colspan="5"><center></center></th>
                <th
                  colspan="3"
                  class=""
                  v-for="(header, index) in course_list"
                  :key="index"
                >
                  <center>{{ header }}</center>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th class=""><center>Sr. No.</center></th>
                <th class=""><center>Roll No.</center></th>
                <th class=""><center>Registration No.</center></th>
                <th class=""><center>Name</center></th>
                <th class=""><center>Division</center></th>
                <th class=""><center>Quota</center></th>
                <th
                  v-for="(header, index) in course_list.length * 2"
                  :key="index"
                >
                  <span v-if="header % 2 == 0">
                    <center>%</center>
                  </span>
                  <span v-else-if="header % 2 == 1">
                    <center>Marks</center>
                  </span>
                </th>
              </tr>
              <tr v-for="(s, index) in learner_course_list" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ s.rollno }}</td>
                <td>{{ s.registration_number }}</td>
                <td>{{ s.name }}</td>
                <td>{{ s.division }}</td>
                <td>{{ s.quota }}</td>
                <td v-for="(header, index) in s.comp_marks" :key="index">
                  <center>{{ header }}</center>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-col>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      overlay: false,
      selected: [],
      snackbar: false,
      course_list: [],
      crs_id: [],
      search: "",
      crs_list: [],
      snackbar_msg: "",
      color: "",
      snackbar: false,
      ay_std_div_list: null,
      sel_ay_data: null,
      std_div_list: null,
      sel_std_data: null,
      div_list: null,
      div: null,
      semester_list: null,
      sem: null,
      fetch_loader: false,
      assessment_detail_list: [],
      assessment_detail: null,
      standard: null,
      division: null,
      course: null,
      ass_Scheme: null,
      academicyear: null,
      ass_detail_list: null,
      learner_course_list: [],
      inst_name: null,
      atotal: null,
      ass_converted_total: null,
      show: false,
      org_basic_data: [],
      default_value: null,
      value: null,
      quota_list: null,
      quota: null,
    };
  },

  methods: {
    fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text =
        tab_text +
        "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
      tab_text =
        tab_text +
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text =
        tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table border='1px'>";
      var exportTable = $("#" + id).clone();
      exportTable.find("input").each(function (index, elem) {
        $(elem).remove();
      });
      tab_text = tab_text + exportTable.html();
      tab_text = tab_text + "</table></body></html>";
      var fileName =
        name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

      //Save the file
      // var blob = new Blob([tab_text], {
      //   type: "application/vnd.ms-excel;charset=utf-8",
      // });
      // window.saveAs(blob, fileName);
      const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
    putnull() {
      this.crs_list = [];
      this.crs_id = [];
    },
    // putnull2() {
    //     (this.assessment_detail_list = []), (this.assessment_detail = null);
    // },
    getreport() {
      this.learner_course_list = [];
      const data = {
        ay: this.sel_ay_data.ay_id,
        standard: this.sel_std_data.std_id,
        crs_id: this.crs_id,
        sem: this.sem,
        div: this.div,
        ass_id: this.assessment_detail,
        quota: this.quota,
       // default_value: this.default_value.value,
        default_value_min: this.default_value.min,
        default_value_max: this.default_value.max,
      };
      this.fetch_loader = true;
      axios
        .post("/Examination/getExamCustReport", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.learner_course_list = res.data.learner_course_list;
            this.course_list = res.data.course_list;
            this.fetch_loader = false;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.fetch_loader = false;
          }
          if (this.learner_course_list == "") {
            this.showSnackbar("#b71c1c", "Student not found!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          this.fetch_loader = false;
        })
        .finally(() => {
          this.fetch_loader = false;
        });
    },
    getassessmentschemedetails() {
      (this.assessment_detail_list = []), (this.assessment_detail = null);
      const data = {
        ay: this.sel_ay_data.ay_id,
        standard: this.sel_std_data.std_id,
        crs_id: this.crs_id,
        sem: this.sem,
      };
      axios
        .post("/Examination/getassessmentschemeforExamCustReport", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.assessment_detail_list = res.data.assessment_detail_list;
          }
          if (res.data.flag == "NO") {
            this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
    getStandardCourse() {
      // let div = this.div.div_id;
      // if (this.div.div_id) {
      //     div = this.div.div_id;
      // } else {
      //     div = this.div;
      // }
      const data = {
        ay: this.sel_ay_data.ay_id,
        standard: this.sel_std_data.std_id,
      };
      axios
        .post("/Examination/getStandardCourse", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.crs_list = res.data.courses_list;
            this.quota_list = res.data.quota_list;
            this.default_value = res.data.default_value;
          }
          if (res.data.flag == "NO") {
            this.showSnackbar(
              "#b71c1c",
              "No courses offered for this standard..."
            ); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
    getStd() {
      this.std_div_list = null;
      this.sel_std_data = null;
      this.div_list = null;
      this.div = null;
      this.std_div_list = this.sel_ay_data.std_list;
    },
    getDiv() {
      this.div_list = ["All"];
      this.div = "All";
      this.div_list = this.sel_std_data.div_list;
      this.div_list.unshift("All");
      this.div = this.div_list[0];
      if (this.div_list.length == 0) {
        alert("No division found!!!");
        this.div_list = null;
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      axios
        .post("/commonAPI/get_ay_std_div")
        .then((res) => {
          this.ay_std_div_list = res.data.data;
          //     this.sel_ay_data = res.data.curr_ay;
          this.semester_list = res.data.sem_list;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.onload();
  },
};
</script>
<style scoped>
tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  font-size: small;
}
tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: small;
}
.radiospace {
  margin: 1rem !important;
  padding: 0%;
}
.btn-css {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #fff !important;
  text-decoration: underline;
  color: #0f2027 !important;
  text-align: left;
}

.btn-css:hover {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #ffff !important;
  color: #0f2027 !important;
  text-decoration: underline;
  text-align: left;
}
.t-row {
  padding: 1rem i !important;
}
.mytable /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
.delete-avatar {
  transition: 0.3s;
  border: 1px solid red;
  margin: 0.2rem !important;
}
.delete-avatar:hover {
  background-color: transparent;
}
.delete-v-icon {
  padding-left: 8px;
  padding-top: 1px;
  font-size: 15px;
}
.delete-v-icon:hover {
  color: white;
}
.v-dialogss {
  bottom: 880;
  right: 0;
}
@media print {
  header,
  footer,
  nav,
  date {
    display: none !important;
  }
  table,
  td,
  tr {
    break-inside: avoid-page;
  }
  img {
    width: 100% !important;
  }
  body,
  tr,
  th,
  td {
    font-size: small !important;
    font-weight: bold !important;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  v-card {
    border: none !important;
  }
  @page {
    size: A4;
    margin-top: none;
    padding-top: none;
    size: 15.5in 15.5in;
  }
  table,
  td,
  tr,
  th {
    text-align: center !important;
    margin-top: none;
    padding: none !important;
    font-weight: bold !important;
    border-bottom: 1px solid black;
    border: 1px solid black;
  }
}
</style>
